import {render} from './bbcode.0.4.0-bobtv'
import appConfig from '../../../app.config'

let options = {};

var fontNames = appConfig.font_names;

var fontFamilies = [];
if (fontNames) {
    var fontEntries = fontNames.split(";");
    for (var i = 0; i < fontEntries.length; i++) {
        var parts = fontEntries[i].split( "/" );
        var compressedFontFamily = parts[0].replace(/\s+/g, '');
        fontFamilies[compressedFontFamily] = parts[1];
    }
}

options.defaultFontFamily = appConfig.default_font_family;
options.fontFamilies = fontFamilies;
options.currentNick = "";

function bbcodeRender(content, opts) {
    return render(
        content,
        typeof opts == 'object' ? Object.assign({}, options, opts) : options
    );
}

export default bbcodeRender;


// WEBPACK FOOTER //
// ./src/3rdparty/bbcode/index.js